export const requisitos = [
  {
    id: 1,
    question: 'Posso eu mesmo cortar ou preciso ir a um cabelereiro?',
    answer:
      'Você mesmo pode cortar, não temos exigências sobre quem cortará, só pedimos que o cabelo venha bem amarrado, com elástico e seco, lembrando que o cabelo tem que estar sem chapinha e sem escova.',
  },
  {
    id: 2,
    question: 'Meu cabelo é repicado vocês aceitam?',
    answer:
      'Sim, apenas pedimos que a menor parte do repicado não esteja muito abaixo dos 20cm.',
  },
  {
    id: 3,
    question: 'Vocês aceitam cabelos cacheados e afros? Como medir?',
    answer:
      'Aceitamos e precisamos muito. No caso dos cabelos cacheados e afros, de preferência, que tenha 15cm seco e enrolado.',
  },
  {
    id: 4,
    question:
      'Cabelo tem prazo de validade? Tenho um cabelo guardado há anos, posso enviar mesmo assim?',
    answer:
      'Se ele estiver em boas condições (sem mofo, sem nós) nós aceitamos sim.',
  },
  {
    id: 5,
    question:
      'Faço química no cabelo, é melhor doar antes ou depois de aplicá-la?',
    answer:
      'Pedimos que nos mande antes de colocar a química, devido ao cheiro que fica no cabelo durante os primeiros dias.',
  },
  {
    id: 6,
    question:
      'Como exatamente tenho que pedir para o cabelereiro cortar meu cabelo?',
    answer:
      'É muito fácil! Se for ao cabeleireiro, avise-o que é para adoção. O corte é o convencional, só precisamos que venha bem amarrado com um elástico. Pode-se cortar em várias mechas ou num único rabo de cavalo. Corte o cabelo, de preferência já seco ou espere secar. O elástico precisa estar bem firme, para que o cabelo não solte.',
  },
  {
    id: 7,
    question: 'É necessário algum cuidado especial?',
    answer:
      'O cabelo precisa estar seco e amarrado. Pedimos que não faça trança nele. Não é necessário colocá-lo em nenhum lugar especial, só precisamos que venha dentro de um saco plástico.',
  },
  {
    id: 8,
    question:
      'Preciso guardar o cabelo em algum tipo de saco plástico especial?',
    answer: 'Não, qualquer saco serve, desde que o cabelo esteja 100% seco.',
  },
  {
    id: 9,
    question: 'Amarrei o cabelo, mas soltou, posso enviar mesmo assim?',
    answer:
      'Depende de como ele se espalhou. Se ficou muito espalhado, infelizmente não temos como utilizar.',
  },
  {
    id: 10,
    question:
      'Eu passo creme/protetor térmico no meu cabelo, posso enviar a doação com creme/protetor térmico ?',
    answer: 'Se for pouco creme sim, para que a doação não fique endurecida.',
  },
  {
    id: 11,
    question: 'Posso mandar o cabelo no formato de trança?',
    answer: 'Não. Cabelos trançados não podem ser utilizados para confecção.',
  },
  {
    id: 12,
    question: 'Posso enviar o cabelo úmido?',
    answer: 'Não. O cabelo apodrecerá no caminho.',
  },
  {
    id: 13,
    question: 'Posso enviar várias mechas ou melhor uma única mecha?',
    answer: 'Pode enviar várias mechas.',
  },
]

export const envio = [
  {
    id: 1,
    question:
      'Me deram cabelos de pessoas desconhecidas, posso mandar todos juntos?',
    answer: 'Pode sim, só pedimos que envie em sacos plásticos separados.',
  },
  {
    id: 2,
    question: 'Posso enviar em envelope ou precisa ser caixa?',
    answer:
      'Nós não temos preferência sobre essa questão, mas às vezes os Correios têm regras próprias.',
  },
  {
    id: 3,
    question: 'Envio via PAC ou Sedex?',
    answer: 'Nós não temos preferência, envie como for mais conveniente.',
  },
  {
    id: 4,
    question: 'Posso levar pessoalmente?',
    answer:
      'Pode sim, basta levar em um de nossos pontos de coletas, os endereços estão disponíveis na aba Pontos de coletas em nosso site.',
  },
  {
    id: 5,
    question: 'Como saber se minha doação chegou?',
    answer:
      'Se você realizou o <a href="/como-ajudar/cadastro" class="underline">Pré-cadastro</a> em nosso site e enviou o número de protocolo junto da sua doação, basta ir até a seção <a href="/certificado" class="underline">“Acompanhe seu Certificado”</a> e digitar o número do protocolo. Lembrando que o certificado fica disponível para download dentro de 40 dias após o recebimento da doação. Se você não realizou o pré-cadastro ou não consegue localizar seu certificado, você pode entrar em contato com a nossa equipe através do e-mail <a href="mailto:comunicacao@cabelegria.org">comunicacao@cabelegria.org</a>, com o assunto “Preciso de ajuda com meu Certificado”, informando os seguintes dados: nome completo, CEP e data aproximada do envio da doação.',
  },
  {
    id: 6,
    question: 'Como confirmar a chegada do cabelo de uma forma rápida?',
    answer:
      'A forma mais rápida de confirmar a doação é através do código de rastreamento que os Correios fornecem dentro da nota fiscal do envio. A Cabelegria confirma o recebimento da doação através da disponibilização do certificado digital para download, em um prazo de até 40 dias após o recebimento da doação.',
  },
  {
    id: 7,
    question: 'Vocês reembolsam o custo de envio dos Correios?',
    answer:
      'Infelizmente não temos recursos financeiros suficientes para devolver este valor aos doadores.',
  },
  {
    id: 8,
    question: 'Estou enviando mais de um cabelo, preciso cadastrar todos?',
    answer:
      'Se você quiser certificado para cada doador, é necessário fazer cadastro de cada um.',
  },
  {
    id: 9,
    question: 'É possível fazer o envio desde Portugal?',
    answer:
      'Sim, é possível. Nesse caso, pedimos que enviem diretamente para o nosso escritório e que adicione os dados do CNPJ da instituição (cadastro de empresas brasileiras): Av. Luíz Dumont Villares, 1.160 - Sala 86 - Jardim São Paulo - São Paulo/SP, 02085-100 - CNPJ: 20.000.573/0001-22',
  },
]

export const certificado = [
  {
    id: 1,
    question: 'O que é o Certificado?',
    answer:
      'O certificado é nossa forma de agradecer o lindo gesto dos doadores e confirmar o recebimento das doações. Ele é digital e fica disponível para download em 40 dias após o recebimento da doação na  seção <a href="/certificado" class="underline">“Acompanhe seu Certificado”</a>. Basta digitar o número de protocolo gerado na ocasião do <a href="/como-ajudar/cadastro" class="underline">Pré-Cadastro</a> no campo indicado. ',
  },
  {
    id: 2,
    question: 'O que preciso fazer para obter um Certificado?',
    answer:
      'Para garantir o seu Certificado de Doação, é necessário realizar o <a href="/como-ajudar/cadastro" class="underline">Pré-Cadastro</a> em nosso site antes do envio da mecha de cabelo. Ao realizar o Pré-Cadastro, você receberá um número de protocolo que deve ser enviado junto da doação pelo correio. O Certificado de Doação fica disponível para download em até 40 dias do recebimento da doação, basta ir até a seção <a href="/certificado" class="underline">“Acompanhe seu Certificado”</a> e digitar o número de protocolo gerado.',
  },
  {
    id: 3,
    question: 'Como faço para gerar o meu Certificado de Doação?',
    answer:
      'O Certificado de Doação fica disponível para download em até 40 dias do recebimento da doação, basta ir até a seção <a href="/certificado" class="underline">“Acompanhe seu Certificado”</a> e digitar o número de protocolo gerado na ocasião do <a href="/como-ajudar/cadastro" class="underline">Pré-Cadastro</a> no campo indicado. Se você não realizou o pré-cadastro ou não consegue localizar seu certificado, você pode entrar em contato com a nossa equipe através do e-mail <a href="mailto:comunicacao@cabelegria.org">comunicacao@cabelegria.org</a>, com o assunto “Preciso de ajuda com meu Certificado”, informando os seguintes dados: nome completo, CEP e data aproximada do envio da doação.',
  },
  {
    id: 4,
    question: 'Meu nome está errado no certificado. Como corrigir?',
    answer:
      'Você pode solicitar a correção do seu nome no certificado através do e-mail <a href="mailto:contato@cabelegria.org">contato@cabelegria.org</a>, com o título Correção de nome – Certificado, informando o seu nome completo de forma correta, o nome que encontrou no site, o endereço informado na doação e a data aproximada do envio da doação.',
  },
  {
    id: 5,
    question: ' Por que minha doação foi recusada?',
    answer:
      'Não recusamos doações, por favor, verifique se a sua doação foi mandada para o endereço correto. <br /><br /> A/C Cabelegria <br /> Caixa Postal – 75207 <br /> São Paulo/SP <br /> CEP. 02415-972',
  },
]

export const confeccao = [
  {
    id: 1,
    question:
      'Como saber se meu cabelo realmente será utilizado para a confecção de perucas?',
    answer:
      'Nós divulgamos todas as entregas feitas, basta conferir em nossas redes sociais. Fazemos entregas dentro de todo o Brasil.',
  },
  {
    id: 2,
    question: 'Quanto custa, em média, a produção de uma peruca?',
    answer: 'Custa, em média, 100 (cem) reais.',
  },
  {
    id: 3,
    question: 'Para quais instituições vocês mandam os cabelos?',
    answer:
      'Atendemos pacientes de diversos hospitais como GRAACC, ITACI, TUUCCA, Hospital Darcy Vargas, entre outros. Tambem enviamos perucas diretamente para pacientes, mediante a comprovação documental, via Correios para qualquer lugar do Brasil. Possuímos 4 Bancos de Perucas, você pode conhecer um pouco sobre eles na aba “Banco de Perucas”. Possuímos também um banco de perucas móvel onde levamos para diversos hospitais do Brasil.',
  },
  {
    id: 4,
    question: 'Posso conhecer a ONG?',
    answer:
      'As visitas podem ser realizadas em nossos Bancos de Perucas, basta checar o dia e horário de funcionamento na aba “Banco de Perucas”',
  },
  {
    id: 5,
    question:
      'Posso conhecer o paciente que receberá a peruca com o meu cabelo?',
    answer:
      'Infelizmente essa possibilidade não existe, pois precisamos de 5 a 7 cabelos para preencher uma peruca e não temos como fazer o controle de qual peruca tem o cabelo de quem.',
  },
  {
    id: 6,
    question: 'Vocês aceitam perucas prontas?',
    answer:
      'Sim, aceitamos perucas prontas. O envio deve ser feito diretamente para o nosso escritório Av. Luíz Dumont Villares, 1.160 - Sala 86 - Jardim São Paulo - São Paulo/SP, 02085-100',
  },
]
